var IssueTypeEnum;
(function (IssueTypeEnum) {
    IssueTypeEnum["BenefitCoding"] = "benefit_coding";
    IssueTypeEnum["Formulary"] = "formulary";
    IssueTypeEnum["Accumulator"] = "accumulator";
    IssueTypeEnum["Overages"] = "overages";
})(IssueTypeEnum || (IssueTypeEnum = {}));
export var issueTypeOptions = [
    { label: 'Benefit Coding', value: IssueTypeEnum.BenefitCoding },
    { label: 'Formulary', value: IssueTypeEnum.Formulary },
    { label: 'Accumulator', value: IssueTypeEnum.Accumulator },
    { label: 'Overages', value: IssueTypeEnum.Overages }
];
var ClientOwnerEnum;
(function (ClientOwnerEnum) {
    ClientOwnerEnum["ImplementationManager"] = "implementation_manager";
    ClientOwnerEnum["AccountManager"] = "account_manager";
})(ClientOwnerEnum || (ClientOwnerEnum = {}));
export var clientOwnerOptions = [
    {
        label: 'Implementation Manager',
        value: ClientOwnerEnum.ImplementationManager
    },
    { label: 'Account Manager', value: ClientOwnerEnum.AccountManager }
];
var ClientStatusEnum;
(function (ClientStatusEnum) {
    ClientStatusEnum["Yes"] = "yes";
    ClientStatusEnum["No"] = "no";
    ClientStatusEnum["Pending"] = "pending";
})(ClientStatusEnum || (ClientStatusEnum = {}));
export var clientStatusOptions = [
    { label: 'Yes', value: ClientStatusEnum.Yes },
    { label: 'No', value: ClientStatusEnum.No },
    { label: 'Pending', value: ClientStatusEnum.Pending }
];
var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum["NotRequired"] = "not_required";
    PaymentStatusEnum["InvoicePending"] = "invoice_pending";
    PaymentStatusEnum["InvoiceSent"] = "invoice_sent";
    PaymentStatusEnum["PaymentReceived"] = "payment_received";
})(PaymentStatusEnum || (PaymentStatusEnum = {}));
export var paymentStatusOptions = [
    { label: 'Not Required', value: PaymentStatusEnum.NotRequired },
    { label: 'Invoice Pending', value: PaymentStatusEnum.InvoicePending },
    { label: 'Invoice Sent', value: PaymentStatusEnum.InvoiceSent },
    { label: 'Payment Received', value: PaymentStatusEnum.PaymentReceived }
];
var AttachmentTypeEnum;
(function (AttachmentTypeEnum) {
    AttachmentTypeEnum["GPIList"] = "GPI Lists";
    AttachmentTypeEnum["SupportingDocumentation"] = "Supporting Documentation";
    AttachmentTypeEnum["ImpactReport"] = "Impact Report";
    AttachmentTypeEnum["Invoice"] = "Invoice";
})(AttachmentTypeEnum || (AttachmentTypeEnum = {}));
export var impactReportAttachmentTypeOptions = [
    { label: 'GPI Lists', value: AttachmentTypeEnum.GPIList },
    {
        label: 'Supporting Documentation',
        value: AttachmentTypeEnum.SupportingDocumentation
    },
    { label: 'Impact Report', value: AttachmentTypeEnum.ImpactReport },
    { label: 'Invoice', value: AttachmentTypeEnum.Invoice }
];
